





































































































































































































































import mixins from 'vue-typed-mixins'
import FlexibleBookingMonthlyCalendar from '@/calendesk/sections/section/shared/mixins/FlexibleBookingMonthlyCalendar'
import EmployeePicker from '@/calendesk/sections/section/shared/components/EmployeePicker.vue'
import BookingTimePicker from '@/components/BookingTimePicker.vue'
import CTimeZonesSelect from '@/components/CTimeZonesSelect.vue'
import CCalendarService from '@/components/CCalendarService.vue'

export default mixins(FlexibleBookingMonthlyCalendar).extend({
  name: 'FlexibleBooking4',
  components: { CCalendarService, CTimeZonesSelect, BookingTimePicker, EmployeePicker },
  mounted () {
    this.numberOfDaysToFetchEvents = this.data.configuration.wb_number_of_days__number__
  }
})
